import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {stageProgramName, UPDATE_CHAT_CLIENT_REPORT} from "../../../constants";
import {ClientLink} from "./ClientLink";
import {clientGetControlAction, clientGetControlListAction} from "../../../actions/clientAction";
import {Loader} from "../../../utils/loader/Loader";
import {Age} from "../../../utils/dateFormat/Age";
import {PeriodDay} from "../../../utils/dateFormat/PeriodDay";
import {ChatAdd} from "./ChatAdd";

const ChatClientControl = (props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const client = useSelector(state => state.chat.client);
  const course = useSelector(state => state.chat.course);
  const reports = useSelector(state => state.chat.reports);
  const reportID = useSelector(state => state.chat.reportID);
  const report = useSelector(state => state.chat.report);


  useEffect(() => {
    if (client && reports === null) {
      dispatch(clientGetControlListAction(client.id));
    } else if (client && !reportID && reports && reports.length > 0) {
      setLoading(true);
      dispatch(clientGetControlAction(reports[0].id, client.id)).then(() => {
        setLoading(false);
      });
    }
  }, [client, reports, dispatch, reportID]);

  const handleChangeReportID = (e) => {
    const value = e.target.value;
    if (value === '') {
      dispatch({type: UPDATE_CHAT_CLIENT_REPORT, item: null})
    } else {
      setLoading(true);
      dispatch(clientGetControlAction(value, client.id)).then(() => {
        setLoading(false);
      });
    }
  };

  if (!client) {
    return null;
  }

  return <React.Fragment>
  <div className="tabs__wrap">
    <ClientLink code={client.code_control_report} isControl={true} clientid={client.id} typeCode={1} />
    <div className="tabs__wrapper">
      <div className="tabs__inner">
        {course && course.product_title !== "" && <div className="tabs__heading"><PeriodDay course={course} title={true} /></div>}
        {course && course.product_title === "" && <div className="tabs__heading">Нет покупки</div>}
        {client.birthday && <div className="tabs__value">
          <Age date={client.birthday}/>
        </div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">
          <select className="tabs__heading__select select" value={reportID} onChange={handleChangeReportID}>
            <option value="">Выберите отчет</option>
            {
              reports && reports.length > 0 && reports.map((i) => <option key={i.id} value={i.id}>Отчет от {i.created}</option>)
            }
          </select>
        </div>
      </div>
    </div>

    {loading && <Loader size="large" padded/>}
    {!loading && report && <React.Fragment>
      <div className="tabs__wrapper">
        <ReportRow title="Вес" value={report.weight} />
        <ReportRow title="Время подъема" value={report.wake_up_time} isTime={true} />

        <ReportRow title="Ступени программы на которой сейчас находится" value={stageProgramName[report.stage_program_currently]} />
        <ReportRow title="Вариант питания" value={report.menu_option} />
        <ReportRow title="День ступени сегодня" value={report.step_day_today} />
        <ReportRow title="Число заполнения отчета" value={report.date_report_completed} />
        <ReportRow title="Количество съеденной клетчатки, какой (растворимой, нерастворимой)" value={report.amount_fiber_eaten} />

        <MealRow content={report.breakfast} title="Завтрак" />
        <MealRow content={report.snack1} title="1-ый перекус" />
        <MealRow content={report.lunch} title="Обед" />
        <MealRow content={report.snack2} title="2-ый перекус" />
        <MealRow content={report.dinner} title="Ужин" />
        <MealRow content={report.snack3} title="3-ый перекус" />
      </div>

      <ReportRowWrapped title="Количество выпитой воды до 15:00" value={report.water_until_15} />
      <ReportRowWrapped title="Количество выпитой воды c 15:00 до 20:00" value={report.water_until_20} />
      <ReportRowWrapped title="Была ли физическая тренировка вчера?" value={report.training_yesterday} />
      <ReportRowWrapped title="Был ли стул (дефекация) вчера и сколько раз в день?" value={report.defecation_yesterday} />
      <ReportRowWrapped title="Время отбоя" value={report.bedtime} isTime={true} />

    </React.Fragment>}

    <div>{client.id && !loading && <ChatAdd/>}</div>
  </div>

</React.Fragment>;
};

function ReportRowWrapped({title, value, isTime = false}) {
  return <div className="tabs__wrapper">
    <ReportRow title={title} value={value} isTime={isTime}/>
  </div>;
}

function ReportRow({title, value, isTime = false}) {
  return <div className="tabs__inner">
    <div className="tabs__heading">{title}</div>
    {!isTime && <div className="tabs__value">{value}</div>}
    {isTime && <div className="tabs__value"><TimeFormatted time={value} /></div>}
  </div>;
}

function MealRow({title, content = ''}) {
  return <React.Fragment>
    <div className="tabs__topic">{title}</div>
    <div className="tabs__inner tabs__inner--single">
      <div className="tabs__value">{content}</div>
    </div>
  </React.Fragment>;
}

function TimeFormatted({time}) {
  const [timeFormatted, setTimeFormatted] = useState(time);
  useEffect(() => {
    if (time) {
      let tm = time.split('T');
      if (tm.length > 1) {
        tm = tm[1].split(':');
        setTimeFormatted(tm[0] + ':' + tm[1]);
      }
    }
  }, [time]);
  return <React.Fragment>{timeFormatted}</React.Fragment>;
}

export default ChatClientControl
